import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import AuthShell from './AuthShell';
import { Field, Spinner } from '../../components/ui';
import { resetPassword } from '../../api/auth';
import { useToast } from '../../context/ToastContext';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const toast = useToast();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    token: params.get('token') || '',
    email: params.get('email') || '',
    password: '',
    password_confirmation: '',
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErrors({});
    setSubmitting(true);
    try {
      await resetPassword(form);
      toast.success('Password reset! You can now sign in.');
      navigate('/login', { replace: true });
    } catch (err) {
      setErrors(err.errors || {});
      toast.error(err.message || 'Could not reset password.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell
      title="Set a new password"
      subtitle="Choose a strong new password for your account."
      footer={
        <Link to="/login" className="font-semibold text-maroon-700 hover:underline">
          ← Back to sign in
        </Link>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        <Field label="Email address" error={errors.email?.[0]}>
          <input
            type="email"
            className="input"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
        </Field>
        <Field label="New password" error={errors.password?.[0]}>
          <input
            type="password"
            className="input"
            autoComplete="new-password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />
        </Field>
        <Field label="Confirm new password">
          <input
            type="password"
            className="input"
            autoComplete="new-password"
            value={form.password_confirmation}
            onChange={(e) => setForm({ ...form, password_confirmation: e.target.value })}
            required
          />
        </Field>
        {!form.token && (
          <Field label="Reset token" error={errors.token?.[0]} hint="From your reset email link.">
            <input
              type="text"
              className="input"
              value={form.token}
              onChange={(e) => setForm({ ...form, token: e.target.value })}
              required
            />
          </Field>
        )}
        <button type="submit" className="btn-primary w-full" disabled={submitting}>
          {submitting ? <Spinner className="h-4 w-4 text-white" /> : 'Reset password'}
        </button>
      </form>
    </AuthShell>
  );
}
